import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/utils/api'

type Args = {
  organizationId: string
  memberId: string
}

export const useDeleteOrgMember = () => {
  const queryClient = useQueryClient()

  return useMutation<{ success: boolean }, Error, Args>({
    mutationFn: async ({ organizationId, memberId }) => {
      const { data } = await api.delete(
        `/organizations/${organizationId}/members/${memberId}`
      )
      return data
    },
    onSuccess: (_, args) => {
      queryClient.invalidateQueries({
        queryKey: ['organization-members', args.organizationId],
      })
    },
  })
}
